import React from 'react';

interface ISelectionsBadge {
  selections: any;
}

const SelectionsBadge: React.FC<ISelectionsBadge> = ({ selections }) => {
  return (
    <div className='selections-badge-container'>
      <div className='selections-badge-num'>{selections.length}</div>
    </div>
  );
};

export default SelectionsBadge;
